import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-user',
  templateUrl: './icon-user.component.html',
  styleUrls: ['./icon-user.component.scss'],
  standalone: true,
})
export class IconUserComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '20';
  @Input() height = '20';
}
